import { AppState } from '../../types';
import { Product } from '../../../types/products';
import { GenericItem } from '../../../types/items';

export const selectProductList = (state: AppState) => state.products.list;

export const selectAvailableToUpgradeProductList = (state: AppState): Product[] => {

  const product = state.user.current?.data?.ref?.active_subscription?.product;

  let subscriptionList = state.products.list.data?.items || [];

  if (product) {
    subscriptionList = subscriptionList.filter((item) => item.product_code !== product.product_code);
  }

  return subscriptionList;
};

export const selectProductOptions = (state: AppState): Array<GenericItem<string | number>> => {
  const subscriptionList = state.products.list.data?.items || [];
  return subscriptionList
    ? subscriptionList.map((item: Product): GenericItem<string> => ({ id: item.product_code, title: item.title }))
    : [];
};

export const selectAvailableToUpgradeProductOptions = (state: AppState): Array<GenericItem<string | number>> => {

  const subscriptionList = selectAvailableToUpgradeProductList(state);

  return subscriptionList
    ? subscriptionList.map((item: Product): GenericItem<string> => ({ id: item.product_code, title: item.title }))
    : [];
};
